export default __webpack_public_path__ + "static/media/Kotak-Bank.37cb89db.webp";